import { createApp } from 'vue'
import Cookies from 'js-cookie';
import FavoritesList from '@/javascripts/common/favorites.vue'
import agentAPI from '@/javascripts/utils/agent_api'

const app = createApp({
  data() {
    return {
      favorite_positions: [],
    }
  },
  components: {
    'favorite': FavoritesList
  },
  mounted() {
    let cookies_fp_ids = []
    let cookie_key = '_fp'
    if(Cookies.get(cookie_key)) { cookies_fp_ids = Cookies.get(cookie_key).split(',') }
    this.setupPositions(cookies_fp_ids)
  },
  methods: {
    setupPositions(cookies_fp_ids){
      if(cookies_fp_ids.length == 0) { return true }
      agentAPI.get('/api/v1/position_by_ids?ids=' + cookies_fp_ids.join(',')).then(
        (response) => {
          let selected_positions = response.data
          for (let i = 0; i < cookies_fp_ids.length; i++) {
            let objectIndex = selected_positions.findIndex(element => element.id === parseInt(cookies_fp_ids[i]))
            if(objectIndex!=-1) { this.favorite_positions.push(selected_positions[objectIndex]) }
          }
        },
        (error) => { console.log(error) }
      );
    },
    removeFp(remove_position_id){
      let objectIndex = this.favorite_positions.findIndex(element => element.id === parseInt(remove_position_id))
      if(objectIndex!=-1) { this.favorite_positions.splice(objectIndex, 1) }
    }
  }
});

const FavoritesVue = app.mount('#favoritesList');
